
export const DISPATCH_STATUS = {
    PENDING_DISPATCH_DISABLED:1,
    PENDING_DISAPTCH_ENABLED:2,
    DISPATCH_DONE_ENABLED:3,
    DISPATCH_DONE_DISABLED:4,
}

const isDriverDispatchedOnDifferentRoute = (params) => {
    // Check if same driver is dispatched on a different route
    return Boolean(params.agGridReact.gridOptions.rowData?.find(dispatch => 
            dispatch.driverNumber === params.data.driverNumber && 
            dispatch.routeName !== params.data.routeName 
            // && dispatch.driverStatus?.includes("Dispatched")
         ));
}

export const tractorAssignedToMultipleDrivers = (params) => {
   return params.data.tractorNumber && params.agGridReact.gridOptions.rowData?.filter(dispatch => dispatch.tractorNumber === params.data.tractorNumber).length > 1
}

export const driverAssignedToMultipleDrivers = (params) => {
  return  params.data.driverId && params.agGridReact.gridOptions.rowData?.filter(dispatch => dispatch.driverId === params.data.driverId).length > 1;
 }

export const getDisaptchStatus = (params) =>{
    if(params.data.dispatchId){
        return DISPATCH_STATUS.DISPATCH_DONE_ENABLED;
    }else if(isDispatchReady(params)){
        return DISPATCH_STATUS.PENDING_DISAPTCH_ENABLED
    }
    return DISPATCH_STATUS.PENDING_DISPATCH_DISABLED
   
}

export const isDispatched = (params) => {
    return (params.data.dispatchId && params.data.driverNumber && params.data.tractorNumber && params.data.tripNumber )
}

export const isDispatchReady = (params) => {
    return (!params.data.dispatchId && params.data.driverNumber && params.data.tractorNumber && params.data.tripNumber )
}